import React, {Component} from 'react';
import {Col, Row} from 'reactstrap';
import {getMySurvey, putFormValues, submitSurveyEntry, amendSurveyEntry} from '../../../gateways/surveys';
import SurveyView from '../../../components/SurveyView';

class View extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const id = this.props.match.params.id;
    const hotelId = this.props.match.params.hotelid;
    return (
      <Row>
        <Col xs={12}>
          <SurveyView
              id={id}
              hotelId={hotelId}
              getData={getMySurvey}
              putData={putFormValues}
              onSubmit={submitSurveyEntry}
              onUnsubmit={amendSurveyEntry} />
        </Col>
      </Row>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/views/MySurveys/View/View.js